import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import { Colors, Metrics } from 'APP/Themes'

export const CheckmarkStyle = {
  marginRight: 3,
}

export const ActivityIconStyle = {
  marginRight: Metrics.baseMargin,
}

export const Card = styled.View`
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: 8px;
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  ${({ theme }) => theme.shadows.normal}
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 0.75}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 1.25}px;
`

export const DateRange = styled(Typography)`
  text-transform: uppercase;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const ProgressRow = styled.View`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`

export const CurrentGroup = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const WeeklyProgressLabel = styled(Typography)<{ achieved?: boolean }>`
  ${({ achieved }) => achieved && `color: ${Colors.accessiblePeppermintText};`}
`

export const ProgressBar = styled.View`
  height: 8px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.buttonLinen};
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
  overflow: hidden;
`

export const CurrentProgress = styled.View<{ ratio: number; achieved?: boolean }>`
  height: 8px;
  border-radius: 4px;
  width: ${({ ratio }) => ratio * 100}%;
  background-color: ${({ theme, achieved }) =>
    achieved ? theme.colors.success : theme.colors.accent};
`

export const NoActivities = styled(Typography)`
  margin-top: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const ActivityRow = styled.View`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const ActivityTypeGroup = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
`
